// prettier-ignore
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector(
      '[data-predictive-search]'
    );
    this.allPredictiveSearchInstances =
      document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.body = document.querySelector('body');
    this.header = document.querySelector('.shopify-section-header');
    this.headerBottom = document.querySelector('.header__bottom');
    this.promoModals = document.querySelectorAll('.search__modal');
    this.collectionLists = document.querySelectorAll('.template-404__collections');
    this.headerInput = document.querySelector('.header__search .search__input');
    this.inputClear = this.querySelector('.custom-search__input-clear');


    document.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') {
        if (this) {
          this.close(true);
        }
      }
    });

    this.calcHeight();
    this.setupEventListeners();

    this.initSearch();

  }

  calcHeight() {
    if (document.querySelector('.predictive-search')) {
      document.documentElement.style.setProperty(
        '--search-height',
        `calc(100vh - ${this.header.getBoundingClientRect().top}px)`
      );
    }
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
  }

  initSearch() {
    // check url for a query param
    const url = new URL(window.location.href);
    const searchTerm = url.searchParams.get('q');
    if (searchTerm) {
      this.input.value = searchTerm;
      this.onFocus();
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    if (this.inputClear) {
      this.inputClear.style.opacity = 1;
    }
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
    if (this.getQuery().length) {
      this.hidePromoBlock();
    } else {
      this.showPromoBlock();
    }
  }

  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a') ||
      event?.submitter?.classList?.contains('card__link')
    )
      event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();
    if (this.classList.contains('search-modal__form')) {
      if (this.headerBottom) {
        this.headerBottom.classList.add('header__bottom--visible');
      }
      if (this.promoModals.length > 0) {
        this.promoModals.forEach(modal => {
          modal.classList.remove('search__modal--hidden');
        });
      }
      if (this.collectionLists.length > 0) {
        this.collectionLists.forEach(list => {
          list.classList.remove('hidden');
        });
      }
    }

    if (!currentSearchTerm.length) {
      return;
    }

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
      if (this.promoModals.length > 0) {
        this.promoModals.forEach(modal => {
          modal.classList.add('search__modal--hidden');
        });
      }
      if (this.collectionLists.length > 0) {
        this.collectionLists.forEach(list => {
          list.classList.add('hidden');
        });
      }
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    if (this.classList.contains('search-modal__form')) {
      if (this.inputClear) {
        this.inputClear.style.opacity = 0;
      }
      if (this.headerBottom) {
        this.headerBottom.classList.remove('header__bottom--visible');
      }
    }

    if (!this.classList.contains('search-modal__form')) {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close(true);
      });
    }
  }

  onBlur() {
    this.headerInput.blur();
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();
    switch (event.code) {
      case 'Enter':
        event.preventDefault();
        this.selectOption();
        break;
      case 'Escape':
        this.close(true);
        this.closeResults(clearSearchTerm);
        if (this.getQuery().length) {
          this.hidePromoBlock();
        } else {
          this.showPromoBlock();
        }
        break;
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      '[data-predictive-search-search-for-text]'
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (
        currentButtonText.matchAll(new RegExp(previousTerm, 'g')).length > 1
      ) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
    if (this.getQuery().length) {
      this.hidePromoBlock();
    } else {
      this.showPromoBlock();
    }
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    // if (this.cachedResults[queryKey]) {
    //   this.renderSearchResults(this.cachedResults[queryKey]);
    //   this.clickSearchTabs();
    //   this.calcHeight();
    //   return;
    // }

    if (this.promoModals.length > 0) {
      this.promoModals.forEach(modal => {
        modal.classList.add('search__modal--hidden');
      });
    }

    if (this.collectionLists.length > 0) {
      this.collectionLists.forEach(list => {
        list.classList.add('hidden');
      });
    }

    // Fetch from the existing endpoint
    const existingFetch = fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&section_id=predictive-search`,
      { signal: this.abortController.signal }
    ).then((response) => {
      if (!response.ok) {
        throw new Error(response.status);
      }
      return response.text();
    });

    let developmentModeUrl = window?.developmentMode?.url ? `${window?.developmentMode?.url}/api/shopify/avis/search?q=${encodeURIComponent(searchTerm)}` : `https://yves-legare-server.vercel.app/api/shopify/avis/search?q=${encodeURIComponent(searchTerm)}`;
    let developmentModeEnabled = window?.developmentMode?.enabled;
    let url = developmentModeEnabled ? developmentModeUrl : `https://yves-legare-server.vercel.app/api/shopify/avis/search?q=${encodeURIComponent(searchTerm)}`;
    let targetStoreHeader = window?.targetStore?.enabled ? window?.targetStore?.value : null;
    let fetchOptions = {
      signal: this.abortController.signal
    };

    if (targetStoreHeader) {
      fetchOptions.headers = {
        'Content-Type': 'application/json',
        'x-target-store': targetStoreHeader
      };
    }

    // Fetch from the new endpoint for "avis"
    const avisFetch = fetch(
      url,
      {
        ...fetchOptions
      }
    ).then((response) => {
      if (!response.ok) {
        throw new Error(response.status);
      }
      return response.json(); // Assuming the new endpoint returns JSON
    });

    // Combine results from both endpoints
    Promise.all([existingFetch, avisFetch])
      .then(([existingText, avisData]) => {

        const parser = new DOMParser();
        const existingDoc = parser.parseFromString(existingText, 'text/html');
        const existingResultsMarkup = existingDoc.querySelector(
          '#shopify-section-predictive-search'
        ).innerHTML;

        // Render the existing results first
        this.renderSearchResults(existingResultsMarkup, avisData);

        // Generate new results markup for "avis"
        const { avisResultsMarkup, avisCount } =
          this.generateAvisResultsMarkup(avisData);

        // Insert avis results into the correct UL element
        const avisListElement = document.querySelector('[data-type="avis"]');
        if (avisListElement) {
          avisListElement.innerHTML = avisResultsMarkup;
        }

        // Update the avis count after rendering
        const avisCountElement = document.querySelectorAll('.search-avis-count');
        if (avisCountElement.length > 0) {
          avisCountElement.forEach((element) => {
            element.textContent = avisCount ?? '0';
          });
        }
        // else {
        //   // Show no results message (all ressources return 0)
        //   const predictiveNoResultAtAll = document.querySelectorAll('.predictive-search__text');
        //   predictiveNoResultAtAll.forEach((element) => {
        //     element.classList.remove('hidden');
        //   });
        // }

        // Show/hide no results message
        const avisListNoResultsElement = document.querySelector('[data-type="no-results-avis"]');
        if (avisListNoResultsElement) {
          avisListNoResultsElement.classList.toggle('hidden', avisCount > 0);
        }

        this.clickSearchTabs();
        this.calcHeight();
      })
      .catch((error) => {
        if (error?.name === 'AbortError') {
          return;
        }
        console.error('Error in fetching or rendering results:', error);
        this.close();
      });

    if (this.getQuery().length) {
      this.hidePromoBlock();
    } else {
      this.showPromoBlock();
    }
  }

  generateAvisResultsMarkup(avisData) {
    const avisCount = avisData.results.length;

    if (avisData.results.length === 0) {
      return { avisResultsMarkup: '', avisCount: 0 };
    }

    // Generate the markup for the avis results
    const avisResultsMarkup = avisData.results
      .map((result) => {

        const matchingAvis = window.avis.find(
          (avis) => avis.unique_id === result.contractId
        );
        const avisUrl = matchingAvis ? matchingAvis.avis_url : `/pages/avis-de-deces/${result.handle || ''}`;
        const imageContent = !result.error ? result?.image?.url : (window.themeVariables.avisImagePlaceholder ?? window.avisSvg);

        const firstName = result.firstName || '';
        const lastName = result.lastName || '';
        const MaidenName = result.MaidenName || '';
        const birthYear = result.birthDate
          ? result.birthDate.split('-')[0]
          : '';
        const deathYear = result.deathDate
          ? result.deathDate.split('-')[0]
          : '';

        let fullName = '';

        if (MaidenName != '' && lastName != '') {
          fullName = `<span>${firstName} ${lastName} (née ${MaidenName})</span>`;
        } else if (lastName === '' && MaidenName != '') {
          fullName = `<span>${firstName} ${MaidenName}</span>`;
        } else if (lastName != '' && firstName != '') {
          fullName = `<span>${firstName} ${lastName}</span>`;
        }

        return `
          <div class="avis-marquee-card">
            <a href="${avisUrl}" class="avis-marquee-card__content">
              <div class="avis-marquee-card__content-image-wrapper tw-relative">
                <img
                    src="${imageContent}"
                    alt=""
                    width="304"
                    height="296"
                    class="avis-marquee-card__img tw-filter tw-grayscale grey-scale"
                >
                <div class="avis__quick-view tw-absolute  tw-z-10">
                  ${window.iconEye}
                </div>
              </div>
              <div class="avis-marquee-card__content-body tw-flex tw-flex-col">
                <div class="tw-flex tw-flex-wrap tw-gap-2">
                  <h5 class="tw-font-bold tw-mt-4 tw-text-left tw-capitalize tw-font-heading">
                    ${fullName}
                  </h5>
                </div>
                <div class="tw-flex tw-gap-1 tw-items-center">
                  ${birthYear ? `<p class="search_avis-result-dates">${birthYear}</p><span class="search_avis-span">-</span>` : ''}
                  ${deathYear ? `<p class="search_avis-result-dates">${deathYear}</p>` : ''}
                </div>
              </div>
            </a>
          </div>
        `;
      })
      .join('');

    // Return both the markup and the count
    return { avisResultsMarkup, avisCount };
  }

  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText =
      this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    console.log('setLiveRegionText', statusText);
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup, avisData) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    if (avisData.results.length === 0) {
      this.querySelector('[data-predictive-search-live-region-count-value]').classList.remove('hidden');
    }

    this.setLiveRegionResults();
    this.open();
    if (this.promoModals.length > 0) {
      this.promoModals.forEach(modal => {
        modal.classList.add('search__modal--hidden');
      });
    }

    if (this.collectionLists.length > 0) {
      this.collectionLists.forEach(list => {
        list.classList.add('hidden');
      });
    }
  }

  clickSearchTabs() {
    const results = this.querySelectorAll('.predictive-search__results-list');
    if (results.length != 0) {
      results[0].classList.add('active');
      this.querySelector('.predictive-search__result-tab').classList.add(
        'active'
      );
      this.querySelectorAll('.predictive-search__result-tab').forEach((tab) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          const typeTarget = tab.dataset.typeTarget;
          this.querySelectorAll('.predictive-search__result-tab').forEach(
            (element) => {
              element.classList.remove('active');
            }
          );
          tab.classList.add('active');

          results.forEach((element) => {
            let resultsType = element.dataset.type;
            if (resultsType == typeTarget) {
              element.classList.add('active');
            } else {
              element.classList.remove('active');
            }
          });
        });
      });
    }
  }

  hidePromoBlock() {
    if (this.classList.contains('search-modal__form')) {
      this.promoModals.forEach(modal => {
        modal.classList.add('search__modal--hidden');
      });
      this.collectionLists.forEach(list => {
        list.classList.add('hidden');
      });
    }
  }

  showPromoBlock() {
    if (this.classList.contains('search-modal__form')) {
      this.promoModals.forEach(modal => {
        modal.classList.remove('search__modal--hidden');
      });
      this.collectionLists.forEach(list => {
        list.classList.remove('hidden');
      });
    }
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(
      this.querySelector('[data-predictive-search-live-region-count-value]')
        .textContent
    );
  }

  open() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    if (this.getQuery().length) {
      this.hidePromoBlock();
    } else {
      this.showPromoBlock();
    }
  }

  close(clearSearchTerm = false) {

    this.closeResults(clearSearchTerm);
    this.isOpen = false;

  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.predictiveSearchResults.removeAttribute('style');
    if (this.getQuery().length) {
      this.hidePromoBlock();
    } else {
      this.showPromoBlock();
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);
